var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdigift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4317_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0H4C1.79086 0 0 1.7269 0 3.85714V23.1429C0 25.2731 1.79086 27 4 27H24C26.2091 27 28 25.2731 28 23.1429V3.85714C28 1.7269 26.2091 0 24 0Z",
    fill: "#0E194F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.06 4.00004C9.17 3.99004 7.33 5.81004 8.17 8.07004H5C4.46957 8.07004 3.96086 8.28075 3.58579 8.65583C3.21071 9.0309 3 9.53961 3 10.07V12.07C3 12.3353 3.10536 12.5896 3.29289 12.7771C3.48043 12.9647 3.73478 13.07 4 13.07H13V10.07H15V13.07H24C24.2652 13.07 24.5196 12.9647 24.7071 12.7771C24.8946 12.5896 25 12.3353 25 12.07V10.07C25 9.53961 24.7893 9.0309 24.4142 8.65583C24.0391 8.28075 23.5304 8.07004 23 8.07004H19.83C21 4.80004 16.6 2.49004 14.57 5.31004L14 6.07004L13.43 5.29004C12.8 4.40004 11.93 4.01004 11.06 4.00004ZM11 6.07004C11.89 6.07004 12.34 7.15004 11.71 7.78004C11.08 8.41004 10 7.96004 10 7.07004C10 6.80482 10.1054 6.55047 10.2929 6.36293C10.4804 6.1754 10.7348 6.07004 11 6.07004ZM17 6.07004C17.89 6.07004 18.34 7.15004 17.71 7.78004C17.08 8.41004 16 7.96004 16 7.07004C16 6.80482 16.1054 6.55047 16.2929 6.36293C16.4804 6.1754 16.7348 6.07004 17 6.07004ZM4 14.07V22.07C4 22.6005 4.21071 23.1092 4.58579 23.4843C4.96086 23.8593 5.46957 24.07 6 24.07H22C22.5304 24.07 23.0391 23.8593 23.4142 23.4843C23.7893 23.1092 24 22.6005 24 22.07V14.07H15V22.07H13V14.07H4Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4317_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdigift);
export default __webpack_public_path__ + "static/media/mdigift.9abb442a43ab49e6a77b4946bc813402.svg";
export { ForwardRef as ReactComponent };